class IpsTagify {
    constructor(inputElm, gateways, currentIpAddress, ipRestrictions) {
        this.ipRestrictions = ipRestrictions;
        this.currentIpAddress = currentIpAddress;
        this.gateways = gateways;
        this.inputElm = inputElm;

        const tagify = this.initTagify();
        this.addMyCurrentIpAddress(tagify);
    }
    addMyCurrentIpAddress(tagify){
        const thisClass = this;
        const addMyCurrentIpAddressButton = document.getElementById('add-my-current-ip-address');
        if(addMyCurrentIpAddressButton){
            addMyCurrentIpAddressButton.addEventListener('click', function () {
                tagify.addTags([{value: thisClass.currentIpAddress, name: thisClass.currentIpAddress}], false, true);
            });
        }
    }
    initTagify(){
        const thisClass = this;

        const onSelectSuggestion = (e) => {
            if( e.detail.event.target.matches('.remove-all-tags')) {
                tagify.removeAllTags();
            }
            // custom class from "dropdownHeaderTemplate"
            else if( e.detail.event.target.matches('.add-all-tags') ) {
                let selectedItems = tagify.dropdown.getAllSuggestionsRefs();
                let tagsToAdd = [];
                for (let i in selectedItems){
                    if(selectedItems[i].attributes.uuid){
                        let obj = thisClass.gateways.find(o => o.value === selectedItems[i].attributes.value.value);
                        tagsToAdd.push(obj);
                    }
                }
                tagify.addTags(tagsToAdd, true, true);
                tagify.dropdown.hide();
            }
        }

        const currentIpAlert = document.querySelector('#current-ip-alert');
        const tagify = new Tagify(thisClass.inputElm, {
            tagTextProp: 'name', // very important since a custom template is used with this property as text
            enforceWhitelist: false,
            skipInvalid: true, // do not remporarily add invalid tags
            edit: false,
            dropdown: {
                classname: "cy-gateways-dropdown",
                closeOnSelect: false,
                enabled: 0,
                maxItems: 500,
                searchKeys: ['ip', 'name', 'iso2', 'city', 'countryName']  // very important to set by which keys to search for suggesttions when typing
            },
            validate(data){
                if(data.uuid){
                    return true;
                }
                return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(data.value)
            },
            templates: {
                tag: this.tagTemplate,
                dropdownItem: this.suggestionItemTemplate,
                dropdownHeader: this.dropdownHeaderTemplate,
                dropdownItemNoMatch: tagData =>
                    `<div class='${tagify.settings.classNames.dropdownItem} text-primary' value="noMatch" tabindex="0" role="option">
                        No Gateways found for: <strong>${tagData.value}</strong>
                    </div>`
            },
            whitelist: thisClass.gateways,
        })
            .on('dropdown:select', onSelectSuggestion)
            .on('add', function(e){
                const tagValue = e.detail.data.ip ? e.detail.data.ip : e.detail.data.value;
                if (thisClass.currentIpAddress === tagValue) {
                    currentIpAlert.classList.add('d-none');
                }
            })
            .on('remove', function(e){
                const tagValue = e.detail.data.ip ? e.detail.data.ip : e.detail.data.value;
                if (thisClass.currentIpAddress === tagValue) {
                    if(!thisClass.getIfImSelected()){
                        currentIpAlert.classList.remove('d-none');
                    }
                }
            });
        if(thisClass.ipRestrictions.length > 0){
            tagify.addTags(thisClass.ipRestrictions, true, true);
            if (!thisClass.ipRestrictions.some(item => item.value === thisClass.currentIpAddress)
                && !thisClass.ipRestrictions.some(item => item === thisClass.currentIpAddress) && !thisClass.getIfImSelected()) {
                currentIpAlert.classList.remove('d-none');
            }
        } else {
            tagify.addTags(thisClass.gateways, true, true);
            if (!thisClass.gateways.some(item => item.ip === thisClass.currentIpAddress)) {
                currentIpAlert.classList.remove('d-none');
            }
        }
        return tagify;
    }
    getIfImSelected(){
        let element = document.querySelector('select[name="excludeAdmins[]"]')
        let data = $(element).select2('data');
        return !!data.some(item => item.element.attributes['data-its-me'].value === '1');
    }
    tagTemplate(tagData){
        const getGatewayTagHtml = (tagData) => {
            if(tagData['uuid']){
                let iconUrl = '/media/goodaccess/country-flags/png100px/' + tagData['iso2'] + '.png';
                return '<div class="d-flex align-items-center p-0">' +
                    '       <div class="symbol symbol-25px me-2 border ga-border-primary-300 symbol-circle rounded-circle">' +
                    '           <div class="symbol-label bg-light-primary border border-2 border-white overflow-hidden">' +
                    '               <img src="' + iconUrl + '" alt="icon" class="h-25px mw-unset">' +
                    '           </div>' +
                    '       </div>' +
                    '       <div class="d-flex justify-content-start flex-column me-2 rounded-0">' +
                    '           <div><span class="fw-bold text-white fs-7">' + tagData['name'] + '</span></div>' +
                    '           <span class="fw-semibold d-block fs-8 text-white mt-1">' + tagData['ip'] + '</span>' +
                    '       </div>' +
                    '   </div>';
            } else {
                return '<span class="fw-semibold d-block fs-7 text-white p-2">' + tagData.name + '</span>';
            }
        }

        return `<tag title="${tagData.name}"
                        contenteditable='false'
                        spellcheck='false'
                        tabIndex="-1"
                        class="tagify__tag p-1 ${tagData.class ? tagData.class : ""}"
                        ${this.getAttributes(tagData)}>
                    <x title='' class='tagify__tag__removeBtn' role='button' aria-label='remove tag'></x>
                    ${getGatewayTagHtml(tagData)}
                </tag>`;
    }

    suggestionItemTemplate(tagData){
        const getGatewayHtml = (tagData) => {
            let iconUrl = '/media/goodaccess/country-flags/png100px/' + tagData['iso2'] + '.png';

            return '   <div class="d-flex align-items-center p-0">' +
                '       <div class="symbol symbol-35px me-2 border ga-border-primary-300 symbol-circle rounded-circle">' +
                '           <div class="symbol-label bg-light-primary border border-2 border-white  overflow-hidden">' +
                '               <img class="h-35px mw-unset" src="' + iconUrl + '" alt="icon">' +
                '           </div>' +
                '       </div>' +
                '       <div class="d-flex justify-content-start flex-column me-2 rounded-0">' +
                '           <div><span class="fw-bold text-primary fs-7">' + tagData['name'] + '</span></div>' +
                '           <span class="fw-semibold d-block fs-8 ga-text-primary-800">' + tagData['ip'] + '</span>' +
                '       </div>' +
                '    </div>';
        }

        return `<div ${this.getAttributes(tagData)}
                    class='tagify__dropdown__item ${tagData.class ? tagData.class : ""}'
                    tabindex="0"
                    role="option">
                    ${getGatewayHtml(tagData)}
                </div>`;
    }

    dropdownHeaderTemplate(suggestions){
        return `<header data-selector='tagify-suggestions-header' class="${this.settings.classNames.dropdownItem}">
                    <div class="d-flex justify-content-between text-primary">
                        <strong class="text-decoration-underline-ga primary add-all-tags">Add All</strong>
                        ${this.value.length ? `<a class='remove-all-tags text-decoration-underline-ga danger text-danger'>Remove all</a>` : ''}
                    </div>
                    <span class="text-primary">${suggestions.length} Gateways</span>
                </header>`;
    }
}
window.IpsTagify = IpsTagify;